import "./Register.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEye,
    faEyeSlash,
    faSignInAlt,
    faCircleInfo
} from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import Swal from "sweetalert2";
import { Loader } from "../../utils/Loader";
import isStrongPassword from "validator/es/lib/isStrongPassword";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { fetchUserByEmail } from "../../utils/GoogleSignIn/GoogleSignInAndUp";
import { GoogleLogin } from "@react-oauth/google";
import sendVerificationEmail from "../../services/SendVerificationEmail";

function Register() {
    const [inputType, setInputType] = useState("password");
    const [password, setpassword] = useState("");
    const [confPassword, setconfPassword] = useState("");
    const [email, setemail] = useState("");
    const [nomValue, setNomValue] = useState("");
    const [prenomValue, setPrenomValue] = useState("");
    const [numeroTelValue, setNumeroTelValue] = useState("");
    const [Civilite, setCivilite] = useState("Madame");
    const [isDataLoading, setDataLoading] = useState(false);
    const [erreurInputName, setErreurInputName] = useState(null);
    const [erreurInputFirstName, setErreurInputFirstName] = useState(null);
    const [erreurInputEmail, setErreurInputEmail] = useState(null);
    const [erreurInputTel, setErreurInputTel] = useState(null);
    const [erreurInputPassword, setErreurInputPassword] = useState(null);
    const [erreurInputPasswordConf, setErreurInputPasswordConf] = useState(null);

    const navigate = useNavigate();

    const setCookie = (token) => {
        Cookies.set("auth_token", token, { expires: 7 });
    };

    const togglePasswordVisibility = () => {
        setInputType(inputType === "password" ? "text" : "password");
    };

    const confirmPasswordVerif = () => {
        return confPassword === password;
    };

    const handleOnblurName = () => {
        if (nomValue.length === 0) {
            setErreurInputName("Nom non renseigné");
        } else {
            setErreurInputName(null)
        }
    }

    const handleOnblurFirstName = () => {
        if (prenomValue.length === 0) {
            setErreurInputFirstName("Prénom non renseigné");
        } else {
            setErreurInputFirstName(null)
        }
    }

    const handleOnblurEmail = () => {
        if (!validator.isEmail(email)) {
            setErreurInputEmail("Format email invalide");
        } else {
            setErreurInputEmail(null)
        }
    }

    const handleOnblurTel = () => {
        if (!validator.isMobilePhone(numeroTelValue) && numeroTelValue.length !== 10) {
            setErreurInputTel("Format numéro de téléphone incorrecte");
        } else {
            setErreurInputTel(null)
        }
    }

    const handleOnblurPassword = () => {
        if (!validator.isStrongPassword(password)) {
            setErreurInputPassword(
                <>
                    1 majuscule, minuscule, chiffre,<br />
                    1 caractère spécial, <br />
                    8 caractères
                </>
            );
        } else {
            setErreurInputPassword(null)
        }
    }

    const handleOnblurConfPassword = () => {
        if (confPassword !== password) {
            setErreurInputPasswordConf("Diffère du mot de passe");
        } else {
            setErreurInputPasswordConf(null)
        }
    }

    const nameLengthVerif = () => {
        return nomValue.length > 0;
    };

    const firstNameLengthVerif = () => {
        return prenomValue.length > 0;
    };

    const emailVerif = () => {
        return validator.isEmail(email);
    };

    const numeroTelVerif = () => {
        return validator.isMobilePhone(numeroTelValue) && numeroTelValue.length === 10;
    };

    const passwordVerif = () => {
        return validator.isStrongPassword(password);
    };

    const checkFormValidity = () => {
        return (
            numeroTelVerif() &&
            emailVerif() &&
            firstNameLengthVerif() &&
            nameLengthVerif() &&
            passwordVerif() &&
            confirmPasswordVerif()
        );
    };

    const generateUniqueId = () => {
        const timestamp = new Date().getTime();
        const uniqueId = `${timestamp}`;
        return uniqueId;
    };


    const isClientWithThisEmail = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}users/${email}`
            );
            const isUser = await response.json();
            if (response.status === 404) {
                return false;
            }
            return isUser === true;
        } catch (error) {
            console.error(error);
        }
    };

    const handleClickRegister = async () => {
        if (checkFormValidity()) {
            const emailNoneAlreadyUse = await isClientWithThisEmail();
            if (!emailNoneAlreadyUse) {
                const newId = generateUniqueId();
                const user = {
                    id: newId,
                    nom: nomValue,
                    prenom: prenomValue,
                    adresseEmail: email,
                    mdp: password,
                    numeroTel: numeroTelValue,
                    role: "client",
                    accountActivated: false,
                };
                console.log(user);
                try {
                    setDataLoading(true)
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}auth/register`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(user),
                        }
                    );
                    if (response.ok) {
                        await sendVerificationEmail(email);
                        const data = await response.json();
                        setCookie(data.token);
                        const userName = `${user.prenom}`;
                        Cookies.set("name", userName, { expires: 7 })
                    } else {
                        console.error("Erreur lors de la création du compte");
                    }
                    setDataLoading(false);
                    !isDataLoading && navigate("/profil/infos-persos",
                        {
                            state: {
                                nom: user.nom,
                                prenom: user.prenom,
                                adresseEmail: user.adresseEmail,
                                numeroTel: user.numeroTel,
                                civilite: user.civilite,
                            }
                        });
                } catch (error) {
                    console.error("Erreur de connexion au serveur:", error);
                }
            } else {
                Swal.fire({
                    text: "Adresse email déjà associé à un compte. Connectez-vous, ou réinitialiser votre mot de passe.",
                    icon: "error",
                    confirmButtonText: "Ok",
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate("/auth/login");
                    }
                });
            }
        } else {
            Swal.fire({
                text: "Erreur dans le formulaire de création de compte",
                icon: "error",
                confirmButtonText: "Ok",
            });
            !isStrongPassword(password) ? setErreurInputPassword(<>
                1 majuscule, minuscule, chiffre,<br />
                1 caractère spécial, <br />
                8 caractères
            </>) : setErreurInputPassword(null);
            !confirmPasswordVerif() ? setErreurInputPasswordConf("Diffère du mot de passe") : setErreurInputPasswordConf(null);
            !validator.isMobilePhone(numeroTelValue) ? setErreurInputTel("Format numéro de téléphone incorrecte") : setErreurInputTel(null);
            !validator.isEmail(email) ? setErreurInputEmail("Format email invalide") : setErreurInputEmail(null);
            !prenomValue.length > 0 ? setErreurInputFirstName("Prénom non renseigné") : setErreurInputFirstName(null);
            !nomValue.length > 0 ? setErreurInputName("Nom non renseigné") : setErreurInputName(null);
        }
    };

    return (
        <div className="auth-page-container">
            <div className="auth-card">
                <div className="auth-form-section">
                    <h2>Créer un compte</h2>

                    <div style={{ display: "flex", gap: "1rem" }}>
                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Nom</label>
                            <div className="input-wrapper">
                                <input
                                    className="input-login"
                                    placeholder="Ex: Dupont"
                                    value={nomValue}
                                    onBlur={handleOnblurName}
                                    onChange={(e) => setNomValue(e.target.value)}
                                    style={erreurInputName ? { borderColor: "#ef4444" } : {}}
                                />
                            </div>
                            {erreurInputName && nomValue.length <= 0 &&
                                <div className="div-error-message-register">
                                    <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                    <p>{erreurInputName}</p>
                                </div>
                            }
                        </div>

                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Prénom</label>
                            <div className="input-wrapper">
                                <input
                                    className="input-login"
                                    placeholder="Ex: Jean"
                                    value={prenomValue}
                                    onBlur={handleOnblurFirstName}
                                    onChange={(e) => setPrenomValue(e.target.value)}
                                    style={erreurInputFirstName ? { borderColor: "#ef4444" } : {}}
                                />
                            </div>
                            {erreurInputFirstName && prenomValue.length <= 0 &&
                                <div className="div-error-message-register">
                                    <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                    <p>{erreurInputFirstName}</p>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Numéro de téléphone</label>
                        <div className="input-wrapper">
                            <input
                                className="input-login"
                                placeholder="06 12 34 56 78"
                                value={numeroTelValue}
                                onBlur={handleOnblurTel}
                                onChange={(e) => setNumeroTelValue(e.target.value)}
                                style={erreurInputTel ? { borderColor: "#ef4444" } : {}}
                            />
                        </div>
                        {erreurInputTel && !numeroTelVerif() &&
                            <div className="div-error-message-register">
                                <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                <p>{erreurInputTel}</p>
                            </div>
                        }
                    </div>

                    <div className="form-group">
                        <label>Adresse email</label>
                        <div className="input-wrapper">
                            <input
                                className="input-login"
                                placeholder="votre@email.com"
                                value={email}
                                onBlur={handleOnblurEmail}
                                onChange={(e) => setemail(e.target.value)}
                                style={erreurInputEmail ? { borderColor: "#ef4444" } : {}}
                            />
                        </div>
                        {erreurInputEmail && !emailVerif() &&
                            <div className="div-error-message-register">
                                <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                <p>{erreurInputEmail}</p>
                            </div>
                        }
                    </div>

                    <div className="form-group">
                        <label>Mot de passe</label>
                        <div className="input-wrapper">
                            <input
                                className="input-login"
                                type={inputType}
                                placeholder="••••••••"
                                value={password}
                                onBlur={handleOnblurPassword}
                                onChange={(e) => setpassword(e.target.value)}
                                style={erreurInputPassword ? { borderColor: "#ef4444" } : {}}
                            />
                            <FontAwesomeIcon
                                icon={inputType === "password" ? faEye : faEyeSlash}
                                id="icon-eye-see-password"
                                onClick={togglePasswordVisibility}
                            />
                        </div>
                        {erreurInputPassword &&
                            <div className="div-error-message-register">
                                <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                <p>{erreurInputPassword}</p>
                            </div>
                        }
                    </div>

                    <div className="form-group">
                        <label>Confirmation mot de passe</label>
                        <div className="input-wrapper">
                            <input
                                className="input-login"
                                type={inputType}
                                placeholder="••••••••"
                                value={confPassword}
                                onBlur={handleOnblurConfPassword}
                                onChange={(e) => setconfPassword(e.target.value)}
                                style={erreurInputPasswordConf ? { borderColor: "#ef4444" } : {}}
                            />
                        </div>
                        {erreurInputPasswordConf && !confirmPasswordVerif() &&
                            <div className="div-error-message-register">
                                <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                <p>{erreurInputPasswordConf}</p>
                            </div>
                        }
                    </div>

                    {isDataLoading ? (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                            <Loader />
                        </div>
                    ) : (
                        <button className="btn-login" onClick={() => handleClickRegister()}>
                            Créer mon compte
                            <FontAwesomeIcon icon={faSignInAlt} className="icon-signIn" />
                        </button>
                    )}

                    <div className="divider">
                        <span>Ou continuer avec</span>
                    </div>

                    <div className="google-login-container">
                        <GoogleLogin
                            onSuccess={credentialResponse => {
                                const decodedToken = jwtDecode(credentialResponse?.credential);
                                fetchUserByEmail(decodedToken, navigate, credentialResponse?.credential);
                            }}
                            onError={() => {
                                console.log('Login Failed');
                            }}
                        />
                    </div>

                    <div className="auth-switch">
                        <span>Déjà un compte ?</span>
                        <span className="bold-text" onClick={() => navigate("/auth/login")}>
                            Connectez-vous
                        </span>
                    </div>
                </div>

                <div className="auth-image-section">
                    <img
                        src="https://res.cloudinary.com/dc1p20eb2/image/upload/v1709209172/Page%20Login/sebastien.png"
                        alt="image décoration connexion"
                    />
                </div>
            </div>
        </div>
    );
}

export default Register;
